import React, { CSSProperties } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { UniqueIdentifier } from '@dnd-kit/core';

interface SortableItemProps {
  id: UniqueIdentifier;
  children: React.ReactNode;
  isEditable: boolean;
}

export const SortableItem = ({ id, children, isEditable }: SortableItemProps) => {
  const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({
    id,
  });

  const style: CSSProperties = {
    listStyle: 'none',
    opacity: isDragging ? 0.4 : undefined,
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    transition,
    cursor: isEditable ? 'pointer' : 'auto',
  };

  return (
    <li ref={setNodeRef} style={style} {...attributes} {...(isEditable ? listeners : {})}>
      {children}
    </li>
  );
};
